// src/components/Navbar.jsx
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import logoLight from '../assets/tenafi-navbar-logo.svg';

export default function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { path: '/', label: 'Dashboard' },
    { path: '/engine', label: 'Engine' },
    { path: '/reports', label: 'Reports' },
    { path: '/revenue', label: 'Revenue' },
    { path: '/upload', label: 'Upload' },
    { path: '/settings', label: 'Settings' },
  ];

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  const linkClasses = (path, mobile = false) => {
    const base = mobile
      ? 'block w-full rounded-xl px-4 py-3 text-sm font-medium transition-colors '
      : 'px-3 py-2 rounded-lg text-sm font-medium transition-colors ';

    return base + (
      isActive(path)
        ? 'bg-white/15 text-white'
        : 'text-white/70 hover:text-white hover:bg-white/10'
    );
  };

  return (
    <nav className="safe-top sticky top-0 z-50 border-b border-white/10 bg-tenafi-green/95 backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src={logoLight} alt="Tenafi AI" className="h-7 w-auto" />
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link key={link.path} to={link.path} className={linkClasses(link.path)}>
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <span className="text-sm text-white/60">{user?.email}</span>
            <button
              type="button"
              onClick={logout}
              className="text-sm font-medium text-white/70 transition-colors hover:text-white"
            >
              Logout
            </button>
          </div>

          <button
            type="button"
            onClick={() => setMobileOpen((current) => !current)}
            className="inline-flex items-center justify-center rounded-xl border border-white/15 p-2.5 text-white/90 hover:bg-white/10 md:hidden"
            aria-label={mobileOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={mobileOpen}
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              {mobileOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 7h16M4 12h16M4 17h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="border-t border-white/10 bg-tenafi-green/98 shadow-xl md:hidden">
          <div className="safe-bottom px-4 pb-4 pt-3">
            <div className="mb-3 rounded-2xl bg-white/10 px-4 py-3">
              <p className="text-[11px] uppercase tracking-[0.24em] text-white/60">Signed In</p>
              <p className="mt-1 break-all text-sm font-medium text-white">{user?.email}</p>
            </div>

            <div className="space-y-2">
              {navLinks.map((link) => (
                <Link key={link.path} to={link.path} className={linkClasses(link.path, true)}>
                  {link.label}
                </Link>
              ))}
            </div>

            <button
              type="button"
              onClick={logout}
              className="mt-4 w-full rounded-xl border border-white/15 px-4 py-3 text-sm font-medium text-white/90 hover:bg-white/10"
            >
              Logout
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
